__turbopack_context__.v({
  "container": "styles-module__CkF62q__container",
  "headingText": "styles-module__CkF62q__headingText",
  "productGrid": "styles-module__CkF62q__productGrid",
  "skeletonCard": "styles-module__CkF62q__skeletonCard",
});
